export * from './csv';
export * from './day';
export * from './school';
export * from './string';
export * from './timeout';
export * from './validators';

  /**
   * Removes fields that are null and emty from object. 
   * Returns undefined in all items in object get removed
   * @param obj {}
   * @returns obj | undefined
   */
  export const nullAndEmptyStringToundefined = (obj: any) => {
    let finalObj: any | undefined = {};
    if (obj && Object.keys(obj).length > 0) {
      Object.keys(obj).forEach(key => {
        if (obj[key] && obj[key] !== '') finalObj[key] = obj[key];
      });
    } else {
      finalObj = undefined
    }
    return  finalObj;
  };
  